var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        appendToBody: true,
        title: "删除目录",
        visible: _vm.dialogDeltreeVisible,
        width: "470px",
        "custom-class": "qm-picture-library-delete-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogDeltreeVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "del-tree-content" }, [
        _c(
          "div",
          { staticClass: "operating-instructions" },
          _vm._l(_vm.operationList, function (item) {
            return _c(
              "div",
              {
                key: item.type,
                staticClass: "del-tree",
                class: {
                  active: _vm.operationType == item.type,
                  "del-tree-image": item.type == 1,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.selectTargetItem(item.type)
                  },
                },
              },
              [
                _c("i", { staticClass: "qm-icon qm-icon-folder" }),
                _c("span", [_vm._v(_vm._s(item.name))]),
                _vm.operationType == item.type
                  ? _c("span", { staticClass: "state-check" }, [
                      _c("i", { staticClass: "el-icon-check" }),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
        _vm.operationType == 1
          ? _c("div", { staticClass: "qm-description" }, [
              _c("i", { staticClass: "qm-icon qm-icon-warn" }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.delType === 1
                      ? "仅删除目录，图片自动移入默认目录"
                      : "仅删除目录，视频自动移入根目录"
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "span",
        {
          staticClass: "del-tree-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogDeltreeVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.delTargetItem } },
            [_vm._v("删除")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }